import { useEffect, useState } from "react";
import OperatorManager from "./OperatorTable";
import Conect from "../../../../../Api/Conect";
import "./OperatorManager.css";

const ChipManager = () => {
  const token = localStorage.getItem("restoken");
  const [operators, setOperators] = useState([]);

  useEffect(() => {
    fetchOperators();
  }, []);

  const fetchOperators = async () => {
    const { data } = await Conect.get(`/b3BlcmF0b3JsaXN0${token}`);
    setOperators(data.data);
  };

  return (
    <OperatorManager
      operators={operators}
      fetchOperators={fetchOperators}
      token={token}
    />
  );
};

export default ChipManager;